import React, { useContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import MultiStepFormContext from "~/contexts/MultiSelectForm/MultiSelectFormContext";
import Button from "~/shared/Btn";
import TextareaInput from "~/shared/TextareaInput";
import TextInput from "~/shared/TextInput";
import { Content, Header, Footer } from "../styles";
import { Row, Col } from "react-bootstrap";
import CheckboxInput from "~/shared/CheckboxInput";

type EcommerceProps = {
    prevStep?: () => void;
    nextStep?: () => void;
    goToStep?: (step: number) => void;
    currentStep: number;
};

const extraFields = {
    photo_cropped_or_white: {
        name: "Fotos com fundo branco ou recortadas",
        value: "",
        type: "texto",
    },
    photo_with_model: {
        name: "Fotos com modelo",
        value: "",
        type: "texto",
    },
    product_type: {
        name: "Tipo de produto",
        value: "",
        type: "texto",
    },
    image_size: {
        name: "Tamanho das imagens",
        value: "",
        type: "texto",
    },
    adicional_info: {
        name: "Informações adicionais",
        value: "",
        type: "texto",
    },
};

const Ecommerce = ({ nextStep, goToStep }: EcommerceProps) => {
    const { values, confirmationStep, handleChange, updateValuesInLocalStorage, setValues } =
        useContext(MultiStepFormContext);

    const [addicionalInfo, setAddicionalInfo] = useState<string>(values?.extra?.adicional_info?.value || "");
    const [photoType, setPhotoType] = useState<string>(values?.extra?.photo_cropped_or_white?.value || "não");
    const [photoWithModel, setPhotoWithModel] = useState<string>(values?.extra?.photo_with_model?.value || "não");
    const [productType, setProductType] = useState<string>(values?.extra?.product_type?.value || "");
    const [imageSize, setImageSize] = useState<string>(values?.extra?.image_size?.value || "");

    const briefing = `Informações das fotos\nFotos com fundo branco ou recortadas: ${
        values?.extra?.photo_cropped_or_white?.value || photoType
    }\nFotos com modelo: ${
        values?.extra?.photo_with_model?.value || photoWithModel
    }\n\nInformações dos produtos\nTipo de produto: ${
        values?.extra?.product_type?.value || productType
    }\nTamanho das imagens: ${values?.extra?.image_size?.value || imageSize}`;

    const handleExtraFieldChange = async (name: string, value: any) => {
        if (Object.keys(extraFields).includes(name)) {
            handleChange(name, { ...extraFields[name], value, type: extraFields[name].type }, { extra: true });
        }
    };

    const validateAndNextStep = () => {
        if (!productType.length || !imageSize.length) {
            return toast.error("Tipo de produto e tamanho da imagem são obrigatórios!");
        }

        if (confirmationStep) {
            updateValuesInLocalStorage();
            return goToStep(confirmationStep);
        }

        return nextStep();
    };

    useEffect(() => {
        const localValues = JSON.parse(localStorage.getItem("values"));
        if (confirmationStep) {
            setValues(localValues);
        }
    }, []);

    useEffect(() => {
        handleChange("briefing", briefing);
    }, [briefing]);

    return (
        <>
            <Header>
                <h1>Defina o briefing do seu job</h1>
                <p>Precisamos de algumas informações para realizar o seu job!</p>
            </Header>

            <Row>
                <Col sm={12} lg={6}>
                    <Content>
                        <div className="title">
                            <p>Informações das fotos</p>
                            <div className="bar" />
                            <Row className="check-content">
                                <Col>
                                    <CheckboxInput
                                        name="photo_cropped_or_white"
                                        label="Fotos com fundo branco ou recortadas"
                                        value={photoType === "sim" ? true : false}
                                        onChange={(name: string, checked: boolean) => {
                                            const value = checked ? "sim" : "não";
                                            console.log("checked:", checked);
                                            handleExtraFieldChange(name, value);
                                            setPhotoType(value);
                                        }}
                                    />
                                </Col>

                                <Col>
                                    <CheckboxInput
                                        name="photo_with_model"
                                        label="Fotos com modelo"
                                        value={photoWithModel === "sim" ? true : false}
                                        onChange={(name: string, checked: boolean) => {
                                            const value = checked ? "sim" : "não";
                                            handleExtraFieldChange(name, value);
                                            setPhotoWithModel(value);
                                        }}
                                    />
                                </Col>
                                <br />
                            </Row>
                        </div>
                    </Content>
                </Col>
                <Col sm={12} lg={6}>
                    <Content>
                        <div className="title">
                            <p>Informações dos produtos</p>
                            <div className="bar" />
                            <Row className="input-content">
                                <Col lg={6}>
                                    <TextInput
                                        name="product_type"
                                        label="Tipo de produto"
                                        value={productType}
                                        onChange={(name: string, value: string) => {
                                            handleExtraFieldChange(name, value);
                                            setProductType(value);
                                        }}
                                    />
                                </Col>

                                <Col lg={6}>
                                    <TextInput
                                        name="image_size"
                                        label="Tamanho das imagens"
                                        value={imageSize}
                                        onChange={(name: string, value: string) => {
                                            handleExtraFieldChange(name, value);
                                            setImageSize(value);
                                        }}
                                    />
                                </Col>
                            </Row>
                        </div>
                    </Content>
                </Col>
            </Row>

            <Content>
                <div className="title">
                    <p>Informações adicionais</p>
                    <div className="bar" />
                    <TextareaInput
                        name="adicional_info"
                        value={addicionalInfo}
                        placeholder="Descreva aqui qualquer informação adicional..."
                        rows={3}
                        onChange={(name: string, value: string) => {
                            handleExtraFieldChange(name, value);
                            setAddicionalInfo(value);
                        }}
                    />
                </div>
            </Content>

            <Footer>
                {confirmationStep ? (
                    <Button block onClick={validateAndNextStep}>
                        Salvar
                    </Button>
                ) : (
                    <>
                        <Button id="clickSegmentNext" block onClick={() => handleChange("category", 0)}>
                            Voltar
                        </Button>
                        <Button id="clickSegmentNext" block onClick={validateAndNextStep}>
                            Continuar
                        </Button>
                    </>
                )}
            </Footer>
        </>
    );
};

export default Ecommerce;
